/** Alt text、Destination URL 等主题布局文本字段最大长度 */
export const THEME_LAYOUT_ALT_AND_DESTINATION_URL_MAX_LENGTH = 200

export const clampThemeLayoutAltOrDestinationUrl = (value: string): string =>
  value.slice(0, THEME_LAYOUT_ALT_AND_DESTINATION_URL_MAX_LENGTH)
